import axios from 'axios';

const BASE_URL_AGENT_PROFILES = '/accounts';

export function getAgentProfiles(account_id, params) {
  return axios.get(`${BASE_URL_AGENT_PROFILES}/${account_id}/agent_profiles`, {
    params,
  });
}

export function createAgentProfile(params, accountID) {
  return axios.post(
    `${BASE_URL_AGENT_PROFILES}/${accountID}/agent_profiles`,
    params
  );
}

export function deleteAgentProfile(agentProfileId, accountID) {
  return axios.delete(
    `${BASE_URL_AGENT_PROFILES}/${accountID}/agent_profiles/${agentProfileId}`
  );
}

export function patchAgentProfile(params, id, accountID) {
  return axios.patch(
    `${BASE_URL_AGENT_PROFILES}/${accountID}/agent_profiles/${id}`,
    params
  );
}
